import type {NavigateFunction} from 'react-router-dom';

/**
 * A react-router 7-ben már nincs a <Router>-nek átadható history példány, a navigáció
 * hookon (useNavigate) keresztül megy. A komponensek nagy része viszont class alapú, és
 * eseménykezelőből navigál, ezért a MainLayoutRoute itt regisztrálja a navigate függvényt,
 * a hívóhelyek pedig a navigateTo()-t használják.
 */
let navigator: NavigateFunction | null = null;

export function setNavigator(next: NavigateFunction): void {
    navigator = next;
}

export function navigateTo(path: string): void {
    if (navigator) {
        navigator(path);
    }
}
